/*eslint no-console: 0*/
// import { mapGetters, mapActions } from 'vuex'
import ProviderService from '../../services/provider'

const  EventBus = window.VueEventBus

import {createNamespacedHelpers} from 'vuex'
import {namespace} from '../../vuexstore'
import { default as raceStore, namespace as raceNamespace, raceType} from '../../vuexstore/modules/race'
const {mapGetters, mapActions} = createNamespacedHelpers([namespace, raceNamespace].join('/'))

import {parseDateTime} from '../../lib/dates'
import {alert, getQS} from '../../lib/utils'
const qs = getQS() || {}
const noHold = !!qs.nohold
/**
 *
 * @param options{storePath: '', get: '', set: '', prefix: '', suffix: ''}
 * @returns {*}
 */
export const mapState = (options) => {
  const {storePath, prefix = '', suffix = '', depth = null} = options
  const states =  _.reduce(storePath, (fns, item, key) => {
    const fnKey = prefix + key + suffix
    if (depth) {
      key = depth + '.' + key
    }
    fns[fnKey] = {
      get() {
        return this.input(key)
      },
      set(value) {
        this.setInput({[key]: value})
      }
    }
    return fns
  }, {})
  return states
}

export default {
  data() {
    return {
      chosenDate: null, // as wrapper for selectedDate
    }
  },
  created() {

  },
  methods: {
    async askAndRemoveSelectedTimeSlot(reason, callback, denied, callbefore) {
      if (!_.isEmpty(this.selectedTimeslots)) {
        const options = {
          message: `Your selected time options will be removed due to ${reason}.`
        }
        options.confirmed = async () => {
          if (callbefore) {
            await callbefore()
          }
          this.cleanTimeslots()
          this.clearLocalCart()
          if (callback) {
            await callback()
          }
        }
        if (denied) {
          options.denied = denied
        }

        this.confirm(options)

      } else {
        if (callback) {
          callback()
        }
      }
    },
    isAnyProcessing() {
      return _.some(this.selectedSlots || {}, ({processing = false}) => processing)
    },
    startHoldAnimation (time, children) {
      this.setTimeslotData({time: time, key: 'processing', value: true})
      this.setRetrievedTimeslotData({time: time, key: 'processing', value: true})
      if (children && children.length) {
        children.forEach(childTime => {
          this.setTimeslotData({time: childTime, key: 'processing', value: true})
          this.setRetrievedTimeslotData({time: childTime, key: 'processing', value: true})
        })
      }
    },

    endHoldAnimation (time, children) {
      this.setTimeslotData({time: time, key: 'processing', value: false})
      this.setRetrievedTimeslotData({time: time, key: 'processing', value: false})
      if (children && children.length) {
        children.forEach(childTime => {
          this.setTimeslotData({time: childTime, key: 'processing', value: false})
          this.setRetrievedTimeslotData({time: childTime, key: 'processing', value: false})
        })
      }
    },

    async holdSlot(slot, quantity, children) {
      if (noHold) {
        return true
      }
      let holds = {}
      const {bookingId, hold, time} = slot
      const childSlots = {}
      const hasChildren = children && children.length

      this.startHoldAnimation(time, children)

      try {
        let newHold = await ProviderService.hold(hold, quantity)
        holds[time] = _.merge({}, hold, newHold, {quantity})
        if (hasChildren) {
          for(let i = 0; i < children.length; i++) {
            let childTime = children[i]
            let childSlot = childSlots[childTime] = this.retrievedTimeslot(childTime)
            let childHold = childSlot.hold
            newHold = await ProviderService.hold(childHold, quantity)
            holds[childTime] = _.merge({}, childHold, newHold, {quantity})
          }
        }

      } catch (e) {
        alert('Unable to set temporary hold on your selected slot. Please try again!', {classes: 'text-danger'})
        const unholds = _.reduce(holds || {}, (items, hold, time) => {
          const holdId = hold && hold.onlineBookingReservationsId
          if (holdId) {
            items.push(holdId)
          }
          return items
        }, [])
        if (unholds.length) {
          ProviderService.unhold(unholds)
        }
        holds = null

      } finally {
        this.endHoldAnimation(time, children)
      }

      return holds
    },
    async unholdSlot(slot, children, noAnimation) {
      if (noHold) {
        return true
      }
      const holds = []
      const holdData = slot.hold || {}
      const time = slot.time

      if (!noAnimation) {
        this.startHoldAnimation(time, children)
      }

      const bookingId = holdData.onlineBookingsId
      let holdId = holdData.onlineBookingReservationsId
      if (holdId) {
        holds.push(holdId)
      }
      this.setTimeslotData({time, key: 'racers', value: 0})
      this.setTimeslotData({time, key: 'hold', value: _.merge({}, holdData, this.holdDefaults)})

      const hasChildren = children && children.length
      if (hasChildren) {
        for(let i = 0; i < children.length; i++) {
          let childTime = children[i]
          let childSlot = this.selectedSlots[childTime] || {}
          let childHold = childSlot.hold || {}
          holdId = childHold.onlineBookingReservationsId
          if (holdId) {
            holds.push(holdId)
          }
          this.setTimeslotData({time: childTime, key: 'racers', value: 0})
          this.setTimeslotData({time: childTime, key: 'hold', value: _.merge({}, childHold, this.holdDefaults)})
        }
      }
      try {
        if (holds.length) {
          await ProviderService.unhold(holds)
        }
      } catch (e) {
        //
      }
      if (!noAnimation) {
        this.endHoldAnimation(time, children)
      }
    },
    async unholdSlots(slots) {
      _.forOwn(slots, async (slot) => {
        await this.unholdSlot(slot)
      })
    },
    async unholdFirstSelectedSlot() {
      const slots = _.values(this.selectedSlots)
      const slot = _.minBy(slots, ({selected}) => 1 * selected)
      if (slot) {
        this.setTimeslotData({time: slot.time, key: 'racers', value: 0})
        this.updateRacersRacesMatrixOnSelection()
        const selectedSlot = _.cloneDeep(slot)
        this.unholdSlot(selectedSlot)
        selectedSlot.selected = false
        this.updateTimeslotSelection(selectedSlot)
        this.updateRacersRacesMatrixOnSelection()
      }
    },
    getEarliestSlotTime(item, slots) {
      slots = slots || _.values(_.get(item, 'payload.options.form.selectedSlots', {}))
      if (!_.isEmpty(slots)) {
        const slot = _.minBy(slots, o => {
          return parseDateTime(o.datetime).valueOf()
        })
        if (slot) {
          return parseDateTime(slot.datetime).toSeconds()
        }
      }
      return null
    },
    updateRacersRacesMatrixOnSelection() {
      const matrix = _.cloneDeep(this.racerRacesMatrix)
      const slots = this.selectedSlots
      const selections = _.values(_.map(slots, ({racers}) => racers))
      const sortedSelections = selections.sort((a, b) => b - a)
      _.forOwn(matrix, ({max}, index) => {
        const selectedRaces = sortedSelections.shift()
        const filled = matrix[index].filled = selectedRaces === max
        if (!filled) {
          return false
        }
      })
      // console.log('update racers matrix', _.cloneDeep(this.racerRacesMatrix))
      this.racerRacesMatrix = matrix
    },
    ...mapActions(Object.keys(raceStore.actions))
  },
  computed: {
    availableVisibleRaces() {
      return _.reduce(this.visibleSlots, (s, {karts}) => s + karts || 0, 0)
    },
    availableRaces(){
      return _.reduce(this.filteredSlotsByRaceType, (s, {karts}) => s + karts || 0, 0)
    },
    maxSelectableRaces() {
      return this.currentMaxSelectableRacesPerSlot || 0
    },
    minSelectableTimeslots() {
      const maxRaces = this.maxRacesPerPlayer
      return maxRaces || 0
    },
    currentMaxSelectableRacesPerSlot() {
      return this.currentMaxSelectableRacesPerSlotForPackages
      // const matrix = this.racerRacesMatrix || []
      // const noSetMatrix = matrix.filter(({filled}) => !filled)
      // const highestItem = _.maxBy(noSetMatrix, ({max}) => max) || {}
      // console.log('get currentMaxSelectableRacesPerSlot', highestItem.max || 0);
      // return highestItem.max || 0
    },

    reservationType: () => raceType,
    ...mapGetters(Object.keys(raceStore.getters)),
    ...mapState({storePath: raceStore.state.form}),
    ...mapState({storePath: raceStore.state.form.contact, depth: 'contact'}),

    superchargedSettings() {
      return this.getSettings('supercharged')
    },
  },
}
